import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, AlertTriangle } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { AdminTitle, Spinner } from "@/admin/AdminLayout";
import { renderField } from "@/admin/fields";

const FIELDS = [
  { key: "title", label: "Sayfa başlığı" },
  { key: "sections", label: "Bölümler", type: "sections" },
  { key: "seo_title", label: "SEO başlığı" },
  { key: "seo_description", label: "SEO açıklaması", type: "area", rows: 2 },
];

export default function PagesManager() {
  const [pages, setPages] = useState(null);
  const [key, setKey] = useState("hakkimizda");
  const [v, setV] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/admin/pages").then((r) => setPages(r.data));
  }, []);
  useEffect(() => {
    if (pages) setV(pages.find((p) => p.key === key));
  }, [pages, key]);

  if (!pages || !v) return <Spinner />;
  const save = async () => {
    setSaving(true);
    try {
      const r = await api.put(`/admin/pages/${key}`, v);
      setPages(pages.map((p) => (p.key === key ? r.data : p)));
      toast.success("Sayfa kaydedildi");
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setSaving(false);
    }
  };
  return (
    <div>
      <AdminTitle title="Sayfalar ve Metinler" desc="Hakkımızda, Kalite ve Güvenlik, Kariyer ve hukuki metinler">
        <button onClick={save} disabled={saving} className="btn-red !py-2" data-testid="page-save-btn">{saving && <Loader2 className="h-4 w-4 animate-spin" />} Kaydet</button>
      </AdminTitle>
      <select value={key} onChange={(e) => setKey(e.target.value)} className="field-input mb-6 max-w-md" data-testid="page-select">
        {pages.map((p) => <option key={p.key} value={p.key}>{p.title}</option>)}
      </select>
      {v.legal && (
        <div className="mb-6 flex gap-3 rounded-lg border border-amber-300 bg-amber-50 p-4 text-sm text-amber-900" data-testid="legal-draft-warning">
          <AlertTriangle className="h-5 w-5 shrink-0" /> Bu metin taslaktır; yayına almadan önce bir hukuk danışmanı tarafından kontrol edilmesi önerilir.
        </div>
      )}
      <div className="space-y-5 rounded-lg border border-zinc-200 bg-white p-5">
        {FIELDS.map((f) => renderField(f, v[f.key], (val) => setV({ ...v, [f.key]: val })))}
      </div>
    </div>
  );
}
